import React, { useEffect } from 'react';
import { initCanvas, initTemplateCode } from './../CanvasActions';

const BackCanvas = React.memo((props) => {
    /* componentDidMount */
    useEffect(() => {
        if (props.templateId !== props.templateCode || ['p1t10', 'p1t17', 'p1t18', 'p2t1', 'p2t2', 'p2t3', 'p2t4', 'p3t1', 'p3t2', 'p3t4',
            'p3t5', 'p3t6', 'p4t1', 'p4t3', 'p10t1', 'p10t2', 'p10t3', 'p10t4', 'p10t5', 'p10t6', 'p10t7', 'p10t8', 'p10t9', 'p10t10', 'p11t1', 'p11t2', 'p11t3', 'p11t4',
            'p11t5', 'p11t6', 'p11t7', 'p11t8', 'p11t9', 'p11t10', 'p11t11', 'p11t12', 'p11t13', 'p11t14', 'p11t15', 'p11t16', 'p11t17', 'p11t18',
            'p11t19', 'p11t20', 'p11t21', 'p11t22', 'p11t23', 'p11t24', 'p11t25', 'p12t1', 'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6', 'p12t7', 'p12t8', 'p12t9', 'p12t10', 
            'p17t1', 'p17t2', 'p17t3', 'p17t4', 'p17t5', 'p18t1', 'p18t2', 'p18t3', 'p18t4', 'p19t1', 'p1t12', 'p21t1', 'p21t2', 'p22t1', 'p22t2', 
            'p22t3'].includes(props.templateCode)) {
            return;
        }
        initTemplateCode(props.templateCode);
        initCanvas();
    }, [props.templateCode, props.templateId]);

    let className = '';
    if (['p1t10', 'p1t17', 'p1t18', 'p2t1', 'p2t2', 'p2t3', 'p2t4', 'p3t1', 'p3t2', 'p3t3', 'p3t4', 'p3t5', 'p3t6', 'p4t1', 'p4t3', 'p10t1',
        'p10t2', 'p10t3', 'p10t4', 'p10t5', 'p10t6', 'p10t7', 'p10t8', 'p10t9', 'p10t10', 'p11t1', 'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7', 'p11t8', 'p11t9',
        'p11t10', 'p11t11', 'p11t12', 'p11t13', 'p11t14', 'p11t15', 'p11t16', 'p11t17', 'p11t18', 'p11t19', 'p11t20', 'p11t21', 'p11t22', 'p11t23', 'p11t24', 'p11t25', 'p12t1',
        'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6', 'p12t7', 'p12t8', 'p12t9', 'p12t10', 'p17t1', 'p17t2', 'p17t3', 'p17t4', 'p17t5', 'p18t1', 'p18t2', 'p18t3', 'p18t4',
        'p19t1', 'p1t12', 'p20t1', 'p20t2', 'p20t3', 'p20t4', 'p20t5', 'p20t6', 'p20t7', 'p20t8', 'p20t9', 'p21t1', 'p21t2', 'p22t1', 'p22t2', 'p22t3'].includes(props.templateCode)) {
        className = ' hidden';
    }

    return (
        <div className={'back-canvas-container' + className}>
            <h5>Back Side</h5>
            <div id="back-canvas"></div>
        </div>
    );
});

export default BackCanvas;
